import { getFieldsOfFamilyInfo } from 'components/forms/FamilyInfo';
import { getFieldsOfIdNumber, IdNumberProps } from 'components/forms/IdNumber';
import { CustomerInfoKeyType } from 'types/customer';

/**
 *
 * @param maskIdNo 掩码证件号
 * @param isSSN 是否为SSN
 * @param type 个人信息类型，baseinfo/baseinfo2，默认不区分
 */
export const getFieldsOfPersonalInfo = (
    maskIdNo: IdNumberProps['maskIdNo'],
    isSSN: boolean,
    type?: 'baseinfo' | 'baseinfo2'
): CustomerInfoKeyType[] => {
    const baseinfoFields: CustomerInfoKeyType[] = ['birthday', 'gender', 'age'];
    const baseinfo2Fields: CustomerInfoKeyType[] = isSSN
        ? ['country', 'born_country']
        : ['country', 'born_country', 'id_type', 'issue_country'];

    if (type === 'baseinfo') {
        return baseinfoFields;
    } else if (type === 'baseinfo2') {
        return baseinfo2Fields.concat(getFieldsOfIdNumber(maskIdNo));
    }

    // 默认是全量字段
    return baseinfoFields.concat(baseinfo2Fields, getFieldsOfIdNumber(maskIdNo), getFieldsOfFamilyInfo());
};
